import { darken, lighten, makeStyles } from '@material-ui/core/styles';
import { headerHeight } from 'config';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;
    return {
        container: {
            marginTop: 50,
            [theme.breakpoints.down('xs')]: {
                marginTop: 20,
            },
        },
        rightSide: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        content: {
            padding: '0 0px',
            maxWidth: '720px',
            marginBottom: theme.spacing(4),
            fontWeight: 400,
            color: isDarkMode ? '#eee' : '#222',
            '& strong': {
                fontWeight: 600,
            },
            '& a': {
                color: theme.palette.primary.main,
                transition: '.2s',
                '&:hover': {
                    color: lighten(theme.palette.primary.main, 0.2),
                },
                '&:active': {
                    color: darken(theme.palette.primary.main, 0.2),
                },
            },
        },
        contentSection: {
            width: '100%',
            marginBottom: '30px',
            padding: 0,
            fontSize: '16px',
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
        },
        leftSide: {
            paddingRight: 60,
            [theme.breakpoints.down('sm')]: {
                paddingRight: 0,
            },
        },
        description: {
            width: '100%',
            padding: '10px 0px',
        },
        postingsContainer: {
            width: '100%',
            marginBottom: theme.spacing(2.5),
            '& .MuiGrid-item': {
                borderBottom: isDarkMode ? '1px solid rgba(38,38,38)' : '1px solid rgb(240,240,240)',
                '&:last-child': {
                    borderBottom: 'none',
                },
            },
        },
        sticky: {
            height: 'fit-content',
            position: '-webkit-sticky',
            top: headerHeight + theme.spacing(2),
            fallbacks: [{ position: 'sticky' }],
        },
        headline: {
            padding: theme.spacing(2, 2.5),
            backgroundColor: isDarkMode ? 'rgb(38,38,38)' : 'rgb(250,250,250)',
        },
        summary: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        sideSection: {
            display: 'flex',
            width: '100%',
            marginBottom: theme.spacing(2.5),
        },
    };
});
